module.exports = __webpack_public_path__ + "static/media/universal.e5f77736.png";